import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';
import { COLORS } from 'styleguide';

const LinkToMaterial = styled(Link)`
  display: inline-block;
  flex: 0 0 72px;
  margin: 2px 7px 10px 2px;
  border-radius: 4px;
  box-shadow: ${props => (props['data-accepted'] ? `0 0 0 2px ${COLORS.primary}` : 'none')};
  transition: transform 0.25s ease-out;

  &:nth-child(4n) {
    margin-right: 0;
  }
`;

export default LinkToMaterial;
